import ViewNewsPage from "./ViewNewsPage";

export default ViewNewsPage;
